export const SUBMIT_ONBOARDING_STEP = "SUBMIT_ONBOARDING_STEP";
export const ONBOARDING_SUCCESS = "ONBOARDING_SUCCESS";
export const ONBOARDING_FAILURE = "ONBOARDING_FAILURE";
